<template>
  <div id="saloon-stand-add-update-dialog" class="custom-modal">
    <div class="modal-body">
      <transition name="el-fade-in" mode="out-in">
        <HolaconLottie   v-if="loading == 'updateScreenLoading' && form == null" key="create-loading"  />
        <el-row v-else key="content-loading">
          <el-row :gutter="10">
            <el-col :span="24">
              <div class="registerform-input-container">
                <div class="custom-label">
                  <label>{{ $t("contentManagement.stands.standSaloon.saloonStandAddUpdate.title") }}</label>
                  <el-tooltip placement="top">
                    <div slot="content" class="custom-tooltip-content"><span>{{ $t("contentManagement.stands.standSaloon.saloonStandAddUpdate.titleMsg") }}</span></div>
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
                <el-input v-model="form.title"></el-input>
                <span class="error">{{ $errorMessage("title", validationErrors) }}</span>
              </div>
            </el-col>
            <el-col :span="24" class="mt-3">
              <div class="registerform-input-container">
                <div class="custom-label">
                  <label>{{ $t("contentManagement.stands.standSaloon.saloonStandAddUpdate.color") }}</label>
                  <el-tooltip placement="top">
                    <div slot="content" class="custom-tooltip-content"><span>{{ $t("contentManagement.stands.standSaloon.saloonStandAddUpdate.colorMsg") }}</span></div>
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
                <el-color-picker v-model="form.color"></el-color-picker>
                <span class="error">{{ $errorMessage("color", validationErrors) }}</span>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="10" class="mt-3">
            <el-col :span="24">
              <div class="custom-section-container">
                <div class="section-header" @click="settingsDock = !settingsDock">
                  <div class="section-title">
                    <div class="section-head">
                      <label>{{ $t("contentManagement.stands.standSaloon.saloonStandAddUpdate.settings") }}</label>
                      <!-- <el-tooltip content="Content" placement="top">
                          <i class="el-icon-info"></i>
                        </el-tooltip> -->
                    </div>
                    <span>{{ $t("contentManagement.stands.standSaloon.saloonStandAddUpdate.settingsMsg") }}</span>
                  </div>
                  <div class="section-accordion">
                    <i class="fa" :class="settingsDock ? 'fa-angle-up' : 'fa-angle-down'"></i>
                  </div>
                </div>
                <transition name="el-zoom-in-top">
                  <div class="section-wrapper" v-show="settingsDock">
                    <div class="custom-set-container" :class="form.isActive ? 'sactive' : 'spassive'">
                      <div class="custom-set-inner">
                        <i class="fa" :class="form.isActive ? 'fa-eye' : 'fa-eye-slash'"></i>
                        <div class="custom-set-info">
                          <label>
                            {{ $t("contentManagement.stands.standSaloon.saloonStandAddUpdate.view") }}
                            <!-- <el-tooltip content="Content" placement="top">
                              <i class="el-icon-info"></i>
                            </el-tooltip> -->
                          </label>
                          <span>{{ $t("contentManagement.stands.standSaloon.saloonStandAddUpdate.viewMsg") }}</span>
                        </div>
                      </div>
                      <div class="custom-set-actions fend">
                        <el-switch v-model="form.isActive"></el-switch>
                      </div>
                    </div>
                  </div>
                </transition>
              </div>
            </el-col>
          </el-row>
        </el-row>
      </transition>
    </div>
    <div class="modal-footer" slot="footer" v-if="form != null && loading != 'updateScreenLoading'">
      <div class="left-buttons">
        <el-button @click="$emit('closeDialog')">{{ $t("contentManagement.stands.standSaloon.saloonStandAddUpdate.close") }}</el-button>
        <template v-if="form.id != null">
          <el-popconfirm @confirm="deleteItem" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
            <el-button slot="reference" type="danger" icon="fas fa-trash"> {{ $t("contentManagement.stands.standSaloon.saloonStandAddUpdate.delete") }}</el-button>
          </el-popconfirm>
        </template>
      </div>
      <div class="right-buttons">
        <el-button type="primary" @click="save">{{ $t("contentManagement.stands.standSaloon.saloonStandAddUpdate.save") }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import ItemInfo from "./ItemInfo";
import GroupAddUpdate from "./GroupAddUpdate";
export default {
  components: { ItemInfo, GroupAddUpdate },
  name: "StandSaloonAddUpdate",
  props: ["id"],
  data() {
    return {
      settingsDock: false,
      form: null,
      loading: false,
      timeout: null,
      logoPercent: 0,
      axios,
      validationErrors: [],
      showInfo: false,
      addGroupModal: false,
    };
  },
  methods: {
    async itemAdded(id) {
      this.addGroupModal = false;
      await this.$store.dispatch("getGroups");
      this.form.groupID = id;
    },
    deleteItem() {
      this.$emit("deleteMe", this.form.id);
      this.$emit("closeDialog");
    },
    save() {
      this.loading = "saveLoading";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("standSaloonAddUpdate", this.form);
        this.validationErrors = res.data.validationErrors;
        if (!res.data.alert.hasError) {
          this.form = res.data.data.item;
          await this.$store.dispatch("getStandSaloons");
        }
        this.loading = false;
      }, 500);
    },
  },
  watch: {
    "form.groupID": function(newVal) {
      if (newVal == -1) {
        this.form.groupID = null;
        this.addGroupModal = true;
      }
    },
  },
  async created() {
    this.loading = "updateScreenLoading";
    if (this.timeout != null) clearTimeout(this.timeout);

    if (this.id != undefined && this.id != null) {
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("getStandSaloon", this.id);
        if (!res.data.alert.hasError) {
          this.form = res.data.data.item;
        } else {
          this.$emit("closeDialog");
        }
        this.loading = false;
      }, 500);
    } else {
      this.timeout = setTimeout(() => {
        this.form = {
          id: null,
          title: null,
          color: null,
          isActive: true,
        };
        this.loading = false;
      }, 500);
    }
  },
};
</script>
<style lang="less" scoped>
.square-color-pick {
  width: 30px;
  height: 15px;
  border-radius: 8px;
  flex-shrink: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/SaloonStandAddUpdate.vue